module.exports = __webpack_public_path__ + "static/009-9c8fd7293b78f3e0fd0e0276bef3496c.jpg";